var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"activity-image-btn",style:({ 'background-color': _vm.bgColor })},[_c('img',{attrs:{"src":_vm.src,"alt":"Digipal icon"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }